var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33325 7.99992C1.33325 4.31325 4.31325 1.33325 7.99992 1.33325C11.6866 1.33325 14.6666 4.31325 14.6666 7.99992C14.6666 11.6866 11.6866 14.6666 7.99992 14.6666C4.31325 14.6666 1.33325 11.6866 1.33325 7.99992ZM9.92672 10.8664C10.1867 11.1264 10.6067 11.1264 10.8667 10.8664C11.1201 10.6064 11.1201 10.1797 10.8667 9.9264L8.94005 7.99974L10.8667 6.07307C11.1267 5.81307 11.1267 5.39307 10.8667 5.13307C10.6067 4.87307 10.1867 4.87307 9.92672 5.13307L8.00005 7.05974L6.07339 5.13307C5.81339 4.87307 5.39339 4.87307 5.13339 5.13307C5.00855 5.25762 4.9384 5.42672 4.9384 5.60307C4.9384 5.77941 5.00855 5.94851 5.13339 6.07307L7.06005 7.99974L5.13339 9.9264C5.00855 10.051 4.9384 10.2201 4.9384 10.3964C4.9384 10.5727 5.00855 10.7418 5.13339 10.8664C5.39339 11.1264 5.81339 11.1264 6.07339 10.8664L8.00005 8.93974L9.92672 10.8664Z",
    fill: "#8C8C8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/CloseCircle.fe3ba935d0bb224abcf87a6af5f7c9d5.svg";
export { ForwardRef as ReactComponent };